import React,{useState} from 'react'
import {Link, useNavigate,useParams} from 'react-router-dom';
import { changePassword } from '../../actions/StudentAction';
import swal from 'sweetalert';

const ChangePassword = () => {
    const navigate = useNavigate()
    const params=useParams();

    const [oldPassword, setOldPassword] = useState({ value:'', error: '' });
    const [password,setPassword]=useState({name:'password',value:'',error:''})
    const [confirmPassword,setConfirmPassword]=useState({name:'confirmPassword',value:'',error:''})

    const [loading,setLoading] = useState();

    const [showPassword,setShowPassword] = useState(false)

    const handleConfirmPasswordChange=(e)=>{
        let value = e.target.value
        value = value.replace(/[^a-zA-Z0-9#!@$%^&*()-_+=</>,.'?]/ig, '')
        setConfirmPassword({...confirmPassword,value:value,error:''})  
    }
    const validation = () => {
        let formIsValid = true
        
        // Old Passowrd
        if (!oldPassword.value) {
            formIsValid = false
            let msg = "Please enter current password"
            setOldPassword({...oldPassword,error:msg})
        }
      
        // Passowrd
        if (!password.value) {
            formIsValid = false
            let msg = "Please enter your password"
            setPassword({...password,error:msg})
        }
        if(password.value.length <= 7){
            formIsValid = false
            let msg = "Password must contain at least 8 characters"
            setPassword({...password,error:msg})
        }

    
        // confirm pass
        if (!confirmPassword.value){
            formIsValid = false
            let msg = "Please confirm you password"
            setConfirmPassword({...confirmPassword,error:msg})
        }
        if (confirmPassword.value!==password.value){
            formIsValid = false
            let msg = "Password is not matching with your new password"
            setConfirmPassword({...confirmPassword,error:msg})
        }
        
        if(formIsValid){
            setOldPassword({...oldPassword,error:''})
            setPassword({...password,error:''})
            setConfirmPassword({...confirmPassword,error:''})

        }
    
        return formIsValid;
    
    }
    const onSubmit = async(e) => {
        e.preventDefault();
        if(validation()){
            setLoading(true)
            const data = {
                // id : params?.id,
                current_password : oldPassword.value,
                new_password : password.value
            }
           try {
            await changePassword(data).then(res => {
                if (res.status) {
                    setLoading(false)
                    swal(res.message,'','success');
                    navigate('/student/dashboard');
                }
                else{
                    setLoading(false)
                    swal(res.message,'','error')
                }
            })
           } catch (error) {
            console.log('change password...',error)
           }
            
           
        }
       

    }

    const handleViewPassword = () => {
        setShowPassword(!showPassword)
    }
  return (
    <div className="container mt-5">
        <div className="row align-items-center border-bottom pb-2">
                <div className="col-6">
                    <h5 className='fw-bold mb-0'>Change Password</h5>
                </div>
                <div className="col-6 text-end">
                    <Link to={'/student/dashboard'} className='text-secondary px-3 border-light border fw-medium py-2 bg-white shadow-sm rounded d-inline-block text-decoration-none'>Go To Dashboard</Link>
                </div>
        </div>

        <div className="row mt-4">
            <div className="col-md-6">
            <form  onSubmit={onSubmit}>
                            <div className="row">
                                <div className="col-lg-12 mb-3">
                                    <div className="form-floating pass_word">
                                        <input type="password" 
                                        className="form-control" 
                                        placeholder="Enter Code" 
                                        value={oldPassword.value}
                                        onChange={(e) => {
                                            let value = e.target.value
                                            value = value.replace(/[^a-zA-Z0-9#!@$%^&*()-_+=</>,.'?]/ig, '')
                                            setOldPassword({...oldPassword,value:value, error:''})}
                                        }
                                        />
                                        <i className="fas fa-eye-slash toggle-password"></i>
                                        <label>Current Password</label>
                                    </div>
                                    {oldPassword.error.length>0 && <div className='invalid-field text-danger fw-semibold mt-1'>{oldPassword.error}</div>}

                                </div>
                                <div className="col-lg-12 mb-3">
                                    <div className="form-floating pass_word">
                                        <input type={showPassword?'text':'password'} 
                                        className="form-control" 
                                        placeholder="Enter Code" 
                                        value={password.value}
                                        onChange={(e) => {
                                            let value = e.target.value
                                            value = value.replace(/[^a-zA-Z0-9#!@$%^&*()-_+=</>,.'?]/ig, '')
                                            setPassword({...password,value:value, error:''})}
                                        }
                                         />
                                        <i className="fas fa-eye-slash toggle-password"></i>
                                        <label>New Password</label>
                                    </div>
                                    {password.error.length>0 && <div className='invalid-field text-danger fw-semibold mt-1'>{password.error}</div>}

                                </div>
                                <div className="col-lg-12 mb-3">
                                    <div className="form-floating pass_word">
                                        <input type={showPassword?'text':'password'} 
                                        className="form-control"
                                        placeholder="Enter Code" 
                                        value={confirmPassword.value}
                                        onChange={handleConfirmPasswordChange}
                                        />
                                        <i className="fas fa-eye-slash toggle-password"></i>
                                        <label  htmlFor="floatingInput">Confirm Password</label>
                                    </div>
                                    {confirmPassword.error.length>0 && <div className='invalid-field text-danger fw-semibold mt-1'>{confirmPassword.error}</div>}

                                </div>

                                <div className="col-md-12 mb-3">
                                    <input className="form-check-input" type="checkbox" id="flexCheckChecked"  onChange={handleViewPassword}/>
                                    <label className="form-check-label ms-2" htmlFor="flexCheckChecked">
                                        Show Password
                                    </label>
                                </div>

                                <div className="col-md-12 mt-2">
                                        {loading ? <button className="btn btn-default" disabled type="button">
                                        <span className="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
                                            Updating...</button>:<button type="submit" className="btn btn-default">Update</button>}
                    
                                </div>

                            </div>
                            </form>
            </div>
        </div>
    </div>
  )
}

export default ChangePassword